/* global axios */
import ApiClient from './ApiClient';

// Deliberately a SEPARATE endpoint from `custom_attribute_definitions`: that
// payload is read by the AI-fill MF, the attributes settings screen, the
// automation editor, the contacts import and the connector contract, and this
// feature must not change its shape. One extra request per session (the map is
// per account, not per conversation) buys that isolation.
class CustomAttributePermissionsAPI extends ApiClient {
  constructor() {
    super('custom_attribute_permissions', { accountScoped: true });
  }

  // { enabled, hidden: { conversation_attribute: [...], contact_attribute: [...] } }
  // Only the hidden keys travel, so an account with nothing configured — which is
  // every account today — gets empty arrays.
  getResolved() {
    return axios.get(`${this.url}/resolved`);
  }
}

export default new CustomAttributePermissionsAPI();
